/* import __COLOCATED_TEMPLATE__ from './card-holder-name-field.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();